import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import {
  FilterStateKeys,
  INew_TableAction,
  INew_TableFIlterNotifier,
  New_TableFilters
} from '@lla-platform/core/core-data-access'
import { UntilDestroy } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'lla-overview-filters-list',
  templateUrl: './overview-filters-list.component.html',
  styleUrls: ['./overview-filters-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OverviewFiltersListComponent {
  @Input() advancedFilterKey: FilterStateKeys
  @Input() tableActions: INew_TableAction
  @Input() tableFilters: New_TableFilters
  @Input() filters: string[] = []

  @Output() filterChanged = new EventEmitter<INew_TableFIlterNotifier>()
  @Output() clearAllFilters = new EventEmitter()
}
